

























































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as rules from '@/rules';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import ImageUploader from '@/components/common/ImageUploader.vue';
import _ from "lodash"
import { getModule } from 'vuex-module-decorators';
import Apps from '@/store/modules/Apps';
import { API, Storage } from 'aws-amplify';

@Component({
    components: { DescriptionEditor, ImageUploader },
})
export default class BasicInputForm extends Vue {

    dialog = false;

    @Prop({ default: false, type: Boolean })
    isDecision!: boolean;

    @Prop({ default: ()=>([]), type: Array })
    generationOptions!: any;

     @Prop({ default: ()=>([]), type: Array })
    generationFunctions!: any;

    @Prop({ default: false, type: Boolean })
    isViewpointList!: boolean;

    @Prop({ default: false, type: Boolean })
    isChoiceList!: boolean;

    @Prop({ default: false, type: Boolean })
    isChoice!: boolean;

    @Prop({ default: "", type: String })
    resourceLabel!: string;

    @Prop({
        type: Array,
        default: () => ([]),
    })
    viewpoints!: any;

    @Prop({
        type: String,
        default: '',
    })
    header!: string;

    @Prop({
        type: Object,
        default: () => ({}),
    })
    formProp!: any;

    @Prop({
        type: Boolean,
        default: false,
    })
    dialogProp!: boolean;

    @Prop({
        type: Boolean,
        default: false,
    })
    loading!: boolean;

    @Prop({
        type: String,
        default: '',
    })
    decisionId!: string;

    private logoUrl:string = '';
    private imageCardUrl:string = '';
    private imagePageUrl:string = '';
    private iconUrl:string = '';
    private commentAdminTag = '';
    private commentUserTag = '';

    private tagsDecision = '';
    private tagsDataScience = '';

    private tagsMarketplace = '';
    private templateApprovedKeys = '';
    private planOptions = [{name: "FREE", value: 0}, {name: "$492 USD", value: 492}, {name: "$996 USD", value: 996}]
    requiredRule = [rules.REQUIRED];
    positiveRule = [((val: any)=> val > 0 ? true: 'Value must be greater than 0')];

    form: any = { name: '', description: '', choiceLabel: '', viewpointLabel: '', factorLabel: '', pluralChoiceLabel: '', pluralViewpointLabel: '', pluralFactorLabel: '', scoringRangeMax: 100, scoringSuffix: '%', addToList: true, viewpointVariation: '', commentAdminTags: [], commentUserTags: [], tagsDecision: [], tagsDataScience: [], tagsMarketplace: [], templateApprovedKeys: [], stripeProductCode: '', templateIcon: '', templateLogo: '', templateImageCard: '', templateImagePage: '', templateDescriptionCard: '', templateDescriptionPage: '', templateTagline: '', decisionTemplateId: '', templatePriceSingle: '', templatePriceMonthly: '', templateApproved: false, templateEnabled: false, generationFunction: ''};

    // add dynamiclly
    formOrig: any = { name: '', description: '',choiceLabel: '', viewpointLabel: '', factorLabel: '', pluralChoiceLabel: '', pluralViewpointLabel: '', pluralFactorLabel: '', scoringRangeMax: 100, scoringSuffix: '%', addToList: true, viewpointVariation: '', commentAdminTags: [], commentUserTags: [], tagsDecision: [], tagsDataScience: [], tagsMarketplace: [], templateApprovedKeys: [], stripeProductCode: '', templateIcon: '', templateLogo: '',  templateImageCard: '',templateImagePage: '', templateDescriptionCard: '', templateDescriptionPage: '', templateTagline: '', decisionTemplateId: '', templatePriceSingle: '', templatePriceMonthly: '', templateApproved: false, templateEnabled: false, generationFunction: '' };

    $refs!: {
        form: HTMLFormElement;
        descriptionField: HTMLInputElement;
        nameField: HTMLInputElement
    };
    
    get isDisabled() {
        if (this.form.name) {
            return false;
        } else {
            return true;
        }
    }

    get isDecisionInMarketplace() {
        return getModule(Apps).decisionTemplateDetailsDictionary[this.decisionId] != null
    }

    mounted() {
        this.dialog = this.dialogProp;
        if (!_.isEmpty(this.formProp)) {
            this.form = Object.assign({}, this.formProp);
            this.formOrig = Object.assign({}, this.formProp);
        }
        // this.getImage();
    }

    get filteredGenerationOptions() {
        if(this.form.generationFunction === 'score_estimation_from_ranking') {
            return [
                'None',
                'Include Scores',
                'Include Slope',
                'Just Scores',
                'Scores to Ranks',
                'Weights to 3 bins quantile',
                'Decision Tree Weights',
            ];
        }
        else {
            return [
                'consensus average',
                'consensus min', 
                'consensus max'
            ]
        }
    }

    // Use to get image from S3 bucket. Probably need in future
    private async getImage(){
        try {
            if (!this.formProp) {
                return;
            }
            if (this.formProp.templateLogo) {
                let logoRes = await Storage.get(this.formProp.templateLogo);
                this.logoUrl =logoRes.toString();
            } else {
                this.logoUrl='';
            }
            if (this.formProp.templateImageCard) {
                let imageCardRes = await Storage.get(this.formProp.templateImageCard);
                this.imageCardUrl = imageCardRes.toString();
            } else {
                this.imageCardUrl = '';
            }
            if (this.formProp.templateImagePage) {
                let imagePageRes = await Storage.get(this.formProp.templateImagePage);
                this.imagePageUrl = imagePageRes.toString();
            } else {
                this.imagePageUrl = '';
            }
            if (this.formProp.templateIcon) {
                let iconRes = await Storage.get(this.formProp.templateIcon);
                this.iconUrl = iconRes.toString();
            } else {
                this.iconUrl = '';
            }
        } catch (error) {
            console.log(error);
        }
    }

    @Watch('formProp')
    onFormProp(newVal: any, oldVal: any) {
        // console.log('decision change')
        this.getImage();
        this.form = Object.assign({}, this.formProp);
        this.formOrig = Object.assign({}, this.formProp);
    }

    @Watch('dialogProp')
    onDialogProp(newVal: any, oldVal: any) {
        this.dialog = this.dialogProp;
        //    this.form = Object.assign({}, this.formOrig);
        setTimeout(() => {
            this.$refs.nameField.focus();
        }, 500);

    }

    async removeImageCard() {
        try {
            Vue.set(this.form, 'templateImageCard', '');
        } catch(error){
            console.log(error);
        }
 
    }

    async removeImagePage() {
        try {
            Vue.set(this.form, 'templateImagePage', '');
        } catch (error) {
            console.log(error);
        }
    }

    async removeImageLogo() {
        try {
            Vue.set(this.form, 'templateLogo', '');
        } catch (error) {
            console.log(error);
        }
    }

    async removeTemplateIcon() {
        try {
            Vue.set(this.form, 'templateIcon', '');
        } catch (error) {
            console.log(error);
        }
    }
    
    async submit() {
        if (!this.$refs.form.validate()) {
            return;
        }
        console.log(this.form);
        this.dialog = false;
        // Used for add/delete imgs in S3
        // await this.checkPictureForSubmit();
        this.$emit('submit', this.form);
        if (this.formOrig.name) {
            this.formOrig = Object.assign({}, this.form);
        } else {
            this.$refs.form.reset();
        }
    }

    // Probably will be used in future to check img for deletion from s3
    private async checkPictureForSubmit(){
        try {
            // check if the image key has been changed. and if the old key exists If it has remove the old file
            if(this.formOrig.templateImageCard !== this.form.templateImageCard && this.formOrig.templateImageCard){
               await Storage.remove(this.formOrig.templateImageCard)
            }
            if(this.formOrig.templateImagePage !== this.form.templateImagePage && this.formOrig.templateImagePage){
               await Storage.remove(this.formOrig.templateImagePage)
            }
            if(this.formOrig.templateLogo !== this.form.templateLogo && this.formOrig.templateLogo){
                await Storage.remove(this.formOrig.templateLogo)
            }
            if(this.formOrig.templateIcon !== this.form.templateIcon && this.formOrig.templateIcon){
                await Storage.remove(this.formOrig.templateIcon)
            }
        } catch (error) {
            console.log(error);
        }
        
    }

    async cancel() {
        this.dialog = false;
        this.$emit('cancel', this.form);
        // await this.checkPictureForCancel();
        if (this.formOrig.name) {
            this.form = Object.assign({}, this.formOrig);
        // check if start a Start a NEW Decision form was canceled
        // and reload the form with default values
        } else if (this.isDecision && !this.formOrig.name) {
            this.form = Object.assign({}, this.formOrig);
        } else {
            this.$refs.form.reset();
        }
    }

    // Probably will be used in future
    private async checkPictureForCancel(){
        try {
             // check if the image key has been changed and if there is new key. 
            // new key means user just uploaded a new image, which means that new image needs to be deleted
            if(this.formOrig.templateImageCard!== this.form.templateImageCard && this.form.templateImageCard){
                await Storage.remove(this.form.templateImageCard)
            }
            if(this.formOrig.templateImagePage!== this.form.templateImagePage && this.form.templateImagePage){
                await Storage.remove(this.form.templateImagePage)
            }
            if(this.formOrig.templateLogo!== this.form.templateLogo && this.form.templateLogo){
                await Storage.remove(this.form.templateLogo)
            }
            if(this.formOrig.templateIcon!== this.form.templateIcon && this.form.templateIcon){
                await Storage.remove(this.form.templateIcon)
            }
        } catch (error) {}
    }

    publish() {
        this.dialog = false;
        Vue.set(this.form, 'templateApproved', true)
        Vue.set(this.form, 'templateEnabled', true)
        console.log(this.form)
        this.$emit('publish', this.form)
    }

    remove() {
        this.dialog = false;
        Vue.set(this.form, 'templateApproved', false)
        Vue.set(this.form, 'templateEnabled', false)
        console.log(this.form)
        this.$emit('remove', this.form)
    }

    sync() {
        this.dialog = false;
        Vue.set(this.form, 'templateApproved', true)
        Vue.set(this.form, 'templateEnabled', true)
        console.log(this.form)
        this.$emit('sync', this.form)
    }

    private onValChange(val: any) {
        this.form.viewpointVariation = val;
    }

    private focusDescription() {
        this.$refs.descriptionField.focus();
    }

    private addCommentAdminTag() {
        let commentAdminTags = _.cloneDeep(this.form.commentAdminTags);
        if(!commentAdminTags) {
            commentAdminTags = [];
        }
        commentAdminTags.push(this.commentAdminTag);
        Vue.set(this.form, 'commentAdminTags', commentAdminTags);
        this.commentAdminTag = '';
    }

    private addCommentUserTag() {
        let commentUserTags = _.cloneDeep(this.form.commentUserTags);
        if(!commentUserTags) {
            commentUserTags = [];
        }
        commentUserTags.push(this.commentUserTag);
        Vue.set(this.form, 'commentUserTags', commentUserTags);
        this.commentUserTag = '';
    }

    private addTagsDecision() {
        let tagsDecision = this.form.tagsDecision;
        if(!tagsDecision) {
            tagsDecision = [];
        }
        tagsDecision.push(this.tagsDecision);
        Vue.set(this.form, 'tagsDecision', tagsDecision);
        this.tagsDecision = '';
    }

    private addTagsDataScience() {
        let tagsDataScience = this.form.tagsDataScience;
        if(!tagsDataScience) {
            tagsDataScience = [];
        }
        tagsDataScience.push(this.tagsDataScience);
        Vue.set(this.form, 'tagsDataScience', tagsDataScience);
        this.tagsDataScience = '';
    }

    private addTagsMarketplace() {
        let tagsMarketplace = this.form.tagsMarketplace;
        if(!tagsMarketplace) {
            tagsMarketplace = [];
        }
        tagsMarketplace.push(this.tagsMarketplace);
        Vue.set(this.form, 'tagsMarketplace', tagsMarketplace);
        this.tagsMarketplace = '';
    }

    private addTemplateApprovedKeys() {
        let templateApprovedKeys = this.form.templateApprovedKeys;
        if(!templateApprovedKeys) {
            templateApprovedKeys = [];
        }
        templateApprovedKeys.push(this.templateApprovedKeys);
        Vue.set(this.form, 'templateApprovedKeys', templateApprovedKeys);
        this.templateApprovedKeys = '';
    }

    private removeCommentAdminTag(index: number) {
        let commentAdminTags = _.cloneDeep(this.form.commentAdminTags);
        commentAdminTags.splice(index, 1);
        Vue.set(this.form, 'commentAdminTags', commentAdminTags);
    }

    private removeCommentUserTag(index: number) {
        let commentUserTags = _.cloneDeep(this.form.commentUserTags);
        commentUserTags.splice(index, 1);
        Vue.set(this.form, 'commentUserTags', commentUserTags);
    }

    private removeTagsDecision(index: number) {
        let tagsDecision = this.form.tagsDecision;
        tagsDecision.splice(index, 1);
        Vue.set(this.form, 'tagsDecision', tagsDecision);
    }

    private removeTagsDataScience(index: number) {
        let tagsDataScience = this.form.tagsDataScience;
        tagsDataScience.splice(index, 1);
        Vue.set(this.form, 'tagsDataScience', tagsDataScience);
    }

    private removeTagsMarketplace(index: number) {
        let tagsMarketplace = this.form.tagsMarketplace;
        tagsMarketplace.splice(index, 1);
        Vue.set(this.form, 'tagsMarketplace', tagsMarketplace);
    }

    private removeTemplateApprovedKeys(index: number) {
        let templateApprovedKeys = this.form.templateApprovedKeys;
        templateApprovedKeys.splice(index, 1);
        Vue.set(this.form, 'templateApprovedKeys', templateApprovedKeys);
    }

    private changeGenerationFunction() {
        if(this.form.generationFunction === 'score_estimation_from_ranking') {
            this.form.viewpoints =  '';
        }

        if(this.form.generationFunction === 'generate_consensus_viewpoint') {
            this.form.viewpoints = []
        }
        this.form.viewpointVariation = '';
    }

}
